import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getMessageSegmentsRpcContract = rpcContract({
  name: "get-message-segments",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    segments: v.array(
      v.object({
        key: v.string(),
        count: v.number(),
        eventTitle: v.optional(v.string()),
      }),
    ),
  }),
});

export const createCreatorMessageRpcContract = rpcContract({
  name: "create-creator-message",
  paramsSchema: v.object({
    title: v.pipe(v.string(), v.minLength(1), v.maxLength(50)),
    content: v.pipe(v.string(), v.minLength(1), v.maxLength(1000)),
    segments: v.pipe(v.array(v.pipe(v.string(), v.minLength(1))), v.minLength(1)),
    ctaEnabled: v.optional(v.boolean()),
    ctaText: v.optional(v.nullable(v.pipe(v.string(), v.maxLength(255)))),
    ctaUrl: v.optional(v.nullable(v.string())),
    scheduledAt: v.optional(v.nullable(v.pipe(v.string(), v.minLength(1)))),
  }),
  resultSchema: v.object({
    id: v.string(),
    status: v.string(),
  }),
});

export const updateCreatorMessageRpcContract = rpcContract({
  name: "update-creator-message",
  paramsSchema: v.object({
    id: v.string(),
    title: v.optional(v.pipe(v.string(), v.minLength(1), v.maxLength(50))),
    content: v.optional(v.pipe(v.string(), v.minLength(1), v.maxLength(1000))),
    segments: v.optional(v.pipe(v.array(v.pipe(v.string(), v.minLength(1))), v.minLength(1))),
    ctaEnabled: v.optional(v.boolean()),
    ctaText: v.optional(v.nullable(v.pipe(v.string(), v.maxLength(255)))),
    ctaUrl: v.optional(v.nullable(v.string())),
    scheduledAt: v.optional(v.nullable(v.pipe(v.string(), v.minLength(1)))),
    status: v.optional(v.picklist(["draft", "scheduled"])),
  }),
  resultSchema: v.object({
    id: v.string(),
    status: v.string(),
  }),
});

export const creatorMessageSchema = v.object({
  id: v.string(),
  title: v.string(),
  content: v.string(),
  status: v.string(),
  segments: v.array(v.string()),
  cta_enabled: v.boolean(),
  cta_text: v.nullable(v.string()),
  cta_url: v.nullable(v.string()),
  scheduled_at: v.nullable(v.string()),
  sent_at: v.nullable(v.string()),
  recipient_count: v.number(),
  delivered_count: v.number(),
  opened_count: v.number(),
  clicked_count: v.number(),
  bounced_count: v.number(),
  created: v.string(),
  last_updated: v.string(),
});

export type CreatorMessage = v.InferOutput<typeof creatorMessageSchema>;

export const getCreatorMessageByIdRpcContract = rpcContract({
  name: "get-creator-message-by-id",
  paramsSchema: v.object({
    id: v.string(),
  }),
  resultSchema: creatorMessageSchema,
});

export const deleteCreatorMessageRpcContract = rpcContract({
  name: "delete-creator-message",
  paramsSchema: v.object({
    id: v.string(),
  }),
  resultSchema: v.object({
    deleted: v.boolean(),
  }),
});

export const archiveCreatorMessageRpcContract = rpcContract({
  name: "archive-creator-message",
  paramsSchema: v.object({
    id: v.string(),
  }),
  resultSchema: v.object({
    archived: v.boolean(),
  }),
});

export type DeleteCreatorMessageParams = v.InferOutput<(typeof deleteCreatorMessageRpcContract)["paramsSchema"]>;
export type DeleteCreatorMessageResult = v.InferOutput<(typeof deleteCreatorMessageRpcContract)["resultSchema"]>;
export type ArchiveCreatorMessageParams = v.InferOutput<(typeof archiveCreatorMessageRpcContract)["paramsSchema"]>;
export type ArchiveCreatorMessageResult = v.InferOutput<(typeof archiveCreatorMessageRpcContract)["resultSchema"]>;
export type CreateCreatorMessageParams = v.InferOutput<(typeof createCreatorMessageRpcContract)["paramsSchema"]>;
export type CreateCreatorMessageResult = v.InferOutput<(typeof createCreatorMessageRpcContract)["resultSchema"]>;
export type UpdateCreatorMessageParams = v.InferOutput<(typeof updateCreatorMessageRpcContract)["paramsSchema"]>;
export type UpdateCreatorMessageResult = v.InferOutput<(typeof updateCreatorMessageRpcContract)["resultSchema"]>;
export type GetCreatorMessageByIdParams = v.InferOutput<(typeof getCreatorMessageByIdRpcContract)["paramsSchema"]>;
export type GetCreatorMessageByIdResult = CreatorMessage;
export type GetMessageSegmentsResult = v.InferOutput<(typeof getMessageSegmentsRpcContract)["resultSchema"]>;
export type MessageSegment = GetMessageSegmentsResult["segments"][number];
